import { SiteConfig } from '../contexts';

export interface ForgeLogoutParams {
	config: SiteConfig | null;
}
